import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { spinnerTypes } from '@Containers/GlobalSpinner/GlobalSpinnerConstants';
import { compose } from 'redux';
import { List } from 'immutable';

const alertsLoad = (Component) => {
  function AlertLoadHOC(props) {
    const {
      alertsIds,
      fetchAlerts,
      showGlobalSpinner,
      hideGlobalSpinner,
      setMounted,
      refetch,
      setRefetch,
      processPageAlertsByAlertId,
      isGlobalSpinnerShown,
    } = props;

    useEffect(() => {
      setMounted(true);

      const fetchData = async () => {
        if (!alertsIds || refetch) {
          showGlobalSpinner(spinnerTypes.progress);
          const alerts = await fetchAlerts(refetch);
          processPageAlertsByAlertId(alerts);
          hideGlobalSpinner();
          if (refetch) {
            setRefetch(false);
          }
        }
      };

      fetchData();

      return () => {
        setMounted(false);
        if (isGlobalSpinnerShown) {
          hideGlobalSpinner();
        }
      };
    }, [alertsIds]);

    return <Component {...props} />;
  }

  AlertLoadHOC.propTypes = {
    alertsIds: PropTypes.instanceOf(List),
    fetchAlerts: PropTypes.func,
    showGlobalSpinner: PropTypes.func,
    hideGlobalSpinner: PropTypes.func,
    setMounted: PropTypes.func,
    refetch: PropTypes.bool,
    setRefetch: PropTypes.func,
    processPageAlertsByAlertId: PropTypes.func,
    isGlobalSpinnerShown: PropTypes.bool,
  };

  return AlertLoadHOC;
};

const alertloadComposed = compose(alertsLoad);
export default alertloadComposed;
